import { appLocale } from 'shared';
import { citizenshipConfig } from '../config';
import type { Country } from '../types';

export const getLocalizedCountryName = ({ name, nameKK, nameEN }: Country) => {
  const locale = appLocale.lib.getAppLocale();
  if (locale === appLocale.config.locales.KK) {
    return nameKK;
  }
  if (locale === appLocale.config.locales.EN) {
    return nameEN;
  }
  return name;
};

export const getCountryNameByCode = (code: string) => {
  const citizenship = citizenshipConfig.countryList.find(
    item => item.code === code,
  );
  return citizenship ? getLocalizedCountryName(citizenship) : '';
};
